
import React, { useState, useEffect } from "react";
import { Routes, Route, useParams, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import MemberList from "../components/member/MemberList";
import MemberAdd from "../components/member/MemberAdd";
import Dashboard from "../components/Dashboard";
import MemberDetail from "../components/member/MemberDetail";
import EventList from "../components/event/EventList";
import EventAdd from "../components/event/EventAdd";
import Event from "../components/event/Event";
import EventDetail from "../components/event/EventDetail";
import EventItemAdd from "../components/event/EventItemAdd";
import EventItemDetail from "../components/event/EventItemDetail";
import AppHeader from "../components/AppHeader";
import TaskAdd from "../components/event/TaskAdd";
import EventHub from "../components/event/EventHub";
import EventAction from "../components/event/EventAction";
import UserAdd from "../components/tenant/UserAdd";
import Integrations from "../components/Integrations";
import AppFooter from "../components/AppFooter";
import MediaPost from "../components/media/MediaPost";
import TenantSettings from './TenantSettings';
import EventMessages from "../components/event/EventMessages";
import CalendarPage from "../pages/CalendarPage";
import PasswordResetForm from "../components/PasswordResetForm";
import ResetPassword from "../components/ResetPassword";
import { MessagesProvider } from "../context/MessagesContext";
import MessageThreadModal from "./messages/MessageThreadModal";
import EventHistory from "./history/EventHistory";
import TenantUsers from "./tenant/TenantUsers";
import UserDetail from "./tenant/UserDetail";
import SchedulePost from "./media/SchedulePost";
import Raffle from "../components/event/Raffle";
import CollaborationInvitation from "../components/tenant/CollaborationInvitation";
import AuctionRaffleSetup from "./event/AuctionRaffleSetup";
import YouTubeIntegration from './YouTubeIntegration';
import YouTubeAnalytics from './YouTubeAnalytics';
import MediaPostEnhanced from './media/MediaPostEnhanced'
import ScheduledPostsList from "./media/ScheduledPostsList";
import ScheduledEventsList from "./event/ScheduledEventsList";
import BillingDashboard from "./payment/BillingDashboard";
import SubscriptionPlans from "./payment/BillingDashboard";
import PaymentMethodForm from "./payment/BillingDashboard";
import QuickPost from "./media/QuickPost";
import PostsList from "./media/PostsList";
import NewPost from "./media/NewPost";

const TenantRoutes = () => {
  const { tenant } = useParams();
  const location = useLocation();
  
  // Hide header and sidebar for all EventAction route variations
  const hideHeaderAndSidebar = location.pathname.toLowerCase().includes("/eventaction") || 
                                location.pathname.toLowerCase().match(/\/event\/[^/]+\/item\/[^/]+\/action$/);

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const toggleSidebar = () => setIsSidebarVisible(v => !v);

  useEffect(() => {
    setIsSidebarVisible(false);
  }, [location.pathname, location.search, location.hash]);

  return (
    <MessagesProvider>
      <div className="tenant-page">
        {!hideHeaderAndSidebar && (
          <div>
            <AppHeader
              isSidebarVisible={isSidebarVisible}
              toggleSidebar={toggleSidebar}
            />
            {isSidebarVisible && <Sidebar tenantId={tenant} />}
          </div>
        )}
        <div className="container">
          <div className="tenant-content">
            <Routes>
              <Route path="reset-password" element={<PasswordResetForm tenantId={tenant} />} />
              <Route path="reset-password/:token" element={<ResetPassword tenantId={tenant} />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />

              <Route path="integrations" element={<Integrations tenantId={tenant} />} />
              <Route path="members" element={<MemberList tenantId={tenant} />} />
              <Route path="memberAdd" element={<MemberAdd tenantId={tenant} />} />
              <Route path="memberDetail" element={<MemberDetail tenantId={tenant} />} />
              <Route path="userAdd" element={<UserAdd tenantId={tenant} />} />

              <Route path="events" element={<EventList tenantId={tenant} />} />
              <Route path="eventAdd" element={<EventAdd tenantId={tenant} />} />
              <Route path=":eventId/event" element={<Event tenantId={tenant} />} />
              <Route path=":eventId/eventDetail" element={<EventDetail tenantId={tenant} />} />
              <Route path=":eventId/eventItemAdd" element={<EventItemAdd tenantId={tenant} />} />
              <Route path=":eventId/:itemId/eventItemDetail" element={<EventItemDetail tenantId={tenant} />} />
              {/* <Route path="events/scheduled" element={<ScheduledEventsList tenantId={tenant} />} /> */}
              <Route path="events/scheduled-events" element={<ScheduledEventsList tenantId={tenant} />} />
              <Route path=":eventId/task" element={<TaskAdd tenantId={tenant} />} />
              <Route path="eventHub" element={<EventHub tenantId={tenant} />} />

              {/* EventAction routes - all variations will hide AppHeader */}
              <Route path="event/:eventId/item/:itemId/action" element={<EventAction tenantId={tenant} />} />
              <Route path=":eventId/:itemId/eventAction" element={<EventAction tenantId={tenant} />} />
              <Route path=":eventId/:itemId/eventaction" element={<EventAction tenantId={tenant} />} />

              <Route path="dashboard" element={<Dashboard tenantId={tenant} />} />
              <Route path="calendar" element={<CalendarPage tenantId={tenant} />} />

              <Route path=":eventId/mediaPost" element={<MediaPost tenantId={tenant} />} />
              <Route path=":eventId/:itemId/mediaPost" element={<MediaPost tenantId={tenant} />} />
              <Route path=":eventId/:itemId/mediaPostEnhanced" element={<MediaPostEnhanced tenantId={tenant} />} />
              {/* <Route path="post" element={<QuickPost tenantId={tenant} />} /> */}

              <Route path="settings" element={<TenantSettings tenantId={tenant} />} />
              <Route path="eventHistory" element={<EventHistory tenantId={tenant} />} />
              <Route path="tenantUsers" element={<TenantUsers tenantId={tenant} />} />
              <Route path=":userId/user" element={<UserDetail tenantId={tenant} />} />

              <Route path=":eventId/schedulePost" element={<SchedulePost tenantId={tenant} />} />
              <Route path=":eventId/:itemId/schedulePost" element={<SchedulePost tenantId={tenant} />} />
              {/* <Route path="media/scheduled" element={<ScheduledPostsList tenantId={tenant} />} /> */}
              <Route path="media/scheduled-posts" element={<ScheduledPostsList tenantId={tenant} />} />
              <Route path="media/schedule" element={<SchedulePost tenantId={tenant} />} />

              <Route path=":eventId/:itemId/raffle" element={<Raffle tenantId={tenant} />} />

              <Route path="collaborate" element={<CollaborationInvitation tenantId={tenant} />} />
              <Route path="youtube" element={<YouTubeIntegration tenantId={tenant} />} />
              <Route path="youtube-analytics" element={<YouTubeAnalytics tenantId={tenant} />} />

              <Route path=":eventId/:itemId/actionSetup" element={<AuctionRaffleSetup tenantId={tenant} />} />

              <Route path="/billing" element={<BillingDashboard tenantId={tenant} />} />
              <Route path="/billing/plans" element={<SubscriptionPlans tenantId={tenant} />} />
              <Route path="/billing/payment-methods" element={<PaymentMethodForm tenantId={tenant} />} />

              <Route path="post" element={<PostsList tenantId={tenant} />} />
              <Route path="post/new" element={<NewPost tenantId={tenant} />} />
            </Routes>
            
            <MessageThreadModal tenantId={tenant} />
          </div>
        </div>
      </div>
    </MessagesProvider>
  );
};

export default TenantRoutes;